import { render, staticRenderFns } from "./SquadList.vue?vue&type=template&id=5ff47a7c&scoped=true&"
import script from "./SquadList.vue?vue&type=script&lang=js&"
export * from "./SquadList.vue?vue&type=script&lang=js&"
import style0 from "./SquadList.vue?vue&type=style&index=0&id=5ff47a7c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff47a7c",
  null
  
)

export default component.exports